import { createAction } from 'redux-actions'
import i18next from 'i18next'

import { createRequestActions } from 'store/actionCreators'
import { GALLERIES_PATH, GALLERY_DELETE_IMAGE_PATH } from 'app/constants/api/galleries.js'
import { GALLERY_IMAGE_DELETE_SUCCESS } from 'app/constants/toastrMessages'
import { DELETE } from 'app/constants/requests'

export const fetchGalleryImages = createRequestActions('GALLERY_IMAGES/GET', organizationId => ({
  request: {
    url: GALLERIES_PATH(organizationId),
  },
}))

export const setPending = createAction('GALLERY_IMAGES/SET_PENDING', pending => ({
  pending,
}))

export const addImageToGallery = createAction('GALLERY_IMAGES/ADD_IMAGE', (url, isConfirmRewriteImage) => ({
  url,
  isConfirmRewriteImage,
}))

export const uploadImage = createAction(
  'GALLERY_IMAGES/UPLOAD_REQUEST',
  (image, formName, formField, s3Entity, isConfirmRewriteImage) => ({
    image,
    formName,
    formField,
    s3Entity,
    isConfirmRewriteImage,
  })
)

export const resetLoaded = createAction('GALLERY_IMAGES/RESET_LOADED')

export const setImageToDelete = createAction('GALLERY_IMAGES/SET_IMAGE_TO_DELETE', url => ({ url }))

export const deleteImageFromGallery = createRequestActions('GALLERY_IMAGES/DELETE_IMAGE', url => ({
  request: {
    url: GALLERY_DELETE_IMAGE_PATH,
    method: DELETE,
    data: { url },
  },
  success: i18next.t(`admin:${GALLERY_IMAGE_DELETE_SUCCESS}`),
}))

export const setSearchBy = createAction('GALLERY_IMAGES/SET_SEARCH_BY', by => ({
  by,
}))

export const confirmRewriteImageTrigger = createAction(
  'GALLERY_IMAGES/CONFIRM_REWRITE_IMAGE_TRIGGER',
  (imageDomainWithId, fileName) => ({
    imageDomainWithId,
    fileName,
  })
)

export const setIsImageNameExist = createAction('GALLERY_IMAGES/SET_IS_IMAGE_NAME_EXIST', value => ({ value }))

export const setIsButtonDisable = createAction('GALLERY_IMAGES/SET_IS_BUTTON_DISABLE', value => ({ value }))

export const updateImageUsagePlaces = createAction(
  'GALLERY_IMAGES/UPDATE_IMAGE_USAGE_PLACES',
  (imagePath, usagePlaces) => ({
    imagePath,
    usagePlaces,
  })
)
